import { useState } from "react";
import { Tabs } from "antd";
import ActivePromotions from "../../components/admin/promotions/ActivePromotions";
import ExpiredPromotions from "../../components/admin/promotions/ExpiredPromotions";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import AddUpdatePromotion from "../../components/admin/promotions/AddUpdatePromotion";

const ServiceProviders = () => {
  const [promotionsActiveTab, setPromotionsActiveTab] = useState("active");

  const [updatePromotionData, setUpdatePromotionData] = useState({
    visible: false,
    data: null,
  });

  const tabItems = [
    {
      key: "active",
      label: "Active Codes",
      children: (
        <ActivePromotions
          updatePromotionData={updatePromotionData}
          setUpdatePromotionData={setUpdatePromotionData}
        />
      ),
    },
    {
      key: "expired",
      label: `Expired Codes`,
      children: <ExpiredPromotions updatePromotionData={updatePromotionData} />,
    },
  ];

  const onTabChange = (key) => {
    setPromotionsActiveTab(key);
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Service Provider Header */}
        <div className="w-full py-4">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold title text-lg text-[#000000]">
              Promotions
            </h2>
            <button
              onClick={() =>
                setUpdatePromotionData({ visible: true, data: null })
              }
              className="text-xs px-3 rounded-2xl py-[9px] bg-[#61373f] text-white font-normal"
            >
              Add Promo Code
            </button>
          </div>
        </div>

        {/* Service Provider */}
        <div className="w-full main-scroll min-h-[calc(100vh-170px)] h-[352px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white">
          <div className="w-full space-tab">
            <Tabs
              defaultActiveKey={promotionsActiveTab}
              items={tabItems}
              onChange={onTabChange}
            />
          </div>

          <AddUpdatePromotion
            updatePromotionData={updatePromotionData}
            setUpdatePromotionData={setUpdatePromotionData}
          />
        </div>
      </div>
    </div>
  );
};

export default withDashboardLayout(ServiceProviders);
